import {
  AI_SERVICE_ENDPOINT,
  ANALYTICS_SERVICE_ENDPOINT,
  APP_AUTH0_DOMAIN,
  APP_ENDPOINT,
  APP_POSTHOG_CLIENT_KEY,
  APP_POSTHOG_PROXY_ENDPOINT,
  BLENDED_INSTALLABLE_FRONTEND_ENDPOINT,
  BLENDED_SERVICE_ENDPOINT,
  BOARD_SERVICE_ENDPOINT,
  CADENCE_SERVICE_ENDPOINT,
  CELEBRATIONS_ENDPOINT,
  CLOUD_API_ENDPOINT,
  DEFAULT_MESSAGE_ENDPOINT,
  DEVICE_COMMUNICATION_SERVICE_ENDPOINT,
  ENVIRONMENT,
  EVENT_BUS_SERVICE_ENDPOINT,
  GUEST_SEND_ENDPOINT,
  HUBSPOT_SYNC_ENDPOINT,
  IMAGE_CONVERTER_ENDPOINT,
  INSIGHTS_SERVICE_ENDPOINT,
  LARAVEL_INSTALLABLES_ENDPOINT,
  MARKETPLACE_SERVICE_ENDPOINT,
  MESSAGE_SERVICE_ENDPOINT,
  MESSAGE_SET_CREATOR_ENDPOINT,
  MESSAGE_SET_CREATOR_INSTALLABLE_FRONTEND_ENDPOINT,
  MESSAGE_SET_PLAYER_INSTALLABLE_FRONTEND_ENDPOINT,
  NOTIFICATIONS_SERVICE_ENDPOINT,
  ORDER_SERVICE_ENDPOINT,
  PARTY_PROMPT_CHALLENGE_ENDPOINT,
  PLATFORM_ENDPOINT,
  PLUS_ROOMS_ENDPOINT,
  PUBLIC_MARKETPLACE_LISTINGS_ENDPOINT,
  RW_ENDPOINT,
  SHARE_ENDPOINT,
  SHORTLINK_SERVICE_ENDPOINT,
  SIMULATOR_SERVICE_ENDPOINT,
  SLACK_INSTALLABLE_ENDPOINT,
  SOCIAL_MEDIA_ENDPOINT,
  SSH_KEY_ENDPOINT,
  SUPERADMIN_AUTH0_CLIENT_ID,
  TASK_RUNNER_SERVICE_ENDPOINT,
  VBML_ENDPOINT,
  VESTABOARD_API_ENDPOINT,
  ZAPIER_ENDPOINT
} from './secrets'

function trimTrailingSlash(value?: string) {
  return (value ?? '').replace(/\/+$/, '')
}

function platformWsUrl(platformEndpoint?: string) {
  const base = trimTrailingSlash(platformEndpoint)
  return `${base.replace(/^http:/, 'ws:').replace(/^https:/, 'wss:')}/ws`
}

export const GRAPHQL_URL = `${trimTrailingSlash(VESTABOARD_API_ENDPOINT)}/graphql`
export const AUTH0_DOMAIN = APP_AUTH0_DOMAIN
export const AUTH0_CLIENT_ID = SUPERADMIN_AUTH0_CLIENT_ID
export const API_BASE_URL = PLATFORM_ENDPOINT
export const AI_SERVICE_BASE_URL = AI_SERVICE_ENDPOINT
export const BOARD_SERVICE_BASE_URL = trimTrailingSlash(BOARD_SERVICE_ENDPOINT)
export const INSTALLABLE_FORM_EMBED_URL = `${trimTrailingSlash(APP_ENDPOINT)}/public/installable-form-embed`
export const POSTHOG_KEY = APP_POSTHOG_CLIENT_KEY
export const POSTHOG_PROXY_ENDPOINT = APP_POSTHOG_PROXY_ENDPOINT ?? ''
export const WS_BASE_URL = platformWsUrl(PLATFORM_ENDPOINT)

function dcsWsUrl(dcsEndpoint?: string) {
  const base = trimTrailingSlash(dcsEndpoint)
  return base.replace(/^http:/, 'ws:').replace(/^https:/, 'wss:')
}

export const DCS_WS_BASE_URL = dcsWsUrl(DEVICE_COMMUNICATION_SERVICE_ENDPOINT)
export const INSIGHTS_BASE_URL = trimTrailingSlash(INSIGHTS_SERVICE_ENDPOINT)
export { ENVIRONMENT }
export const LARAVEL_ENDPOINT = LARAVEL_INSTALLABLES_ENDPOINT

// Maps production endpoint URL → current environment endpoint URL.
// Used to rewrite configuration URLs when importing a CSV exported from production.
export const ENDPOINT_REPLACEMENTS = ([
  ['https://ai-service.vestaboard.com', AI_SERVICE_ENDPOINT ?? ''],
  ['https://reports.vestaboard.com', ANALYTICS_SERVICE_ENDPOINT ?? ''],
  ['https://web.vestaboard.com', APP_ENDPOINT ?? ''],
  ['https://blended-installable.vestaboard.com', BLENDED_INSTALLABLE_FRONTEND_ENDPOINT ?? ''],
  ['https://blended.vestaboard.com', BLENDED_SERVICE_ENDPOINT ?? ''],
  ['https://board-service.vestaboard.com', BOARD_SERVICE_ENDPOINT ?? ''],
  ['https://installable.vestaboard.com', CADENCE_SERVICE_ENDPOINT ?? ''],
  ['https://celebrations.vestaboard.com', CELEBRATIONS_ENDPOINT ?? ''],
  ['https://cloud.vestaboard.com', CLOUD_API_ENDPOINT ?? ''],
  ['https://default-message.vestaboard.com', DEFAULT_MESSAGE_ENDPOINT ?? ''],
  ['https://event-bus.fly.dev', EVENT_BUS_SERVICE_ENDPOINT ?? ''],
  ['https://guest-send.vestaboard.com', GUEST_SEND_ENDPOINT ?? ''],
  ['https://hubspot-sync.vestaboard.com', HUBSPOT_SYNC_ENDPOINT ?? ''],
  ['https://image-converter.vestaboard.com', IMAGE_CONVERTER_ENDPOINT ?? ''],
  ['https://insights.vestaboard.com', INSIGHTS_SERVICE_ENDPOINT ?? ''],
  ['https://f31e349e.installables.vbrd.net', LARAVEL_INSTALLABLES_ENDPOINT ?? ''],
  ['https://marketplace-service.vestaboard.com', MARKETPLACE_SERVICE_ENDPOINT ?? ''],
  ['https://message-service.vestaboard.com', MESSAGE_SERVICE_ENDPOINT ?? ''],
  ['https://message-set-creator.vestaboard.com', MESSAGE_SET_CREATOR_ENDPOINT ?? ''],
  ['https://channel-creator.vestaboard.com', MESSAGE_SET_CREATOR_INSTALLABLE_FRONTEND_ENDPOINT ?? ''],
  ['https://message-set-installable.netlify.app', MESSAGE_SET_PLAYER_INSTALLABLE_FRONTEND_ENDPOINT ?? ''],
  ['https://notifications.vestaboard.com', NOTIFICATIONS_SERVICE_ENDPOINT ?? ''],
  ['https://order-service.vestaboard.com', ORDER_SERVICE_ENDPOINT ?? ''],
  ['https://party-prompt-challenge.fly.dev', PARTY_PROMPT_CHALLENGE_ENDPOINT ?? ''],
  ['https://platform.vestaboard.com', PLATFORM_ENDPOINT ?? ''],
  ['https://vb.plus', PLUS_ROOMS_ENDPOINT ?? ''],
  ['https://channels.vestaboard.com', PUBLIC_MARKETPLACE_LISTINGS_ENDPOINT ?? ''],
  ['https://rw.vestaboard.com', RW_ENDPOINT ?? ''],
  ['https://inspired.vestaboard.com', SHARE_ENDPOINT ?? ''],
  ['https://join.vb.plus', SHORTLINK_SERVICE_ENDPOINT ?? ''],
  ['https://digital.vestaboard.com', SIMULATOR_SERVICE_ENDPOINT ?? ''],
  ['https://slack.vestaboard.com', SLACK_INSTALLABLE_ENDPOINT ?? ''],
  ['https://social-counter.vestaboard.com', SOCIAL_MEDIA_ENDPOINT ?? ''],
  ['https://ssh.vestaboard.com', SSH_KEY_ENDPOINT ?? ''],
  ['https://brilliant-deploy-29uz2.ampt.app', TASK_RUNNER_SERVICE_ENDPOINT ?? ''],
  ['https://cloud.vestaboard.com', VBML_ENDPOINT ?? ''],
  ['https://api.vestaboard.com', VESTABOARD_API_ENDPOINT ?? ''],
  ['https://zapier.vestaboard.com', ZAPIER_ENDPOINT ?? ''],
  ['https://dcs.vestaboard.com', DEVICE_COMMUNICATION_SERVICE_ENDPOINT ?? '']
] as Array<[string, string]>).filter(([prod, current]) => prod !== current && current !== '')
// On production, every secret equals its hard-coded production URL so the filter yields an empty
// array and replaceEndpointUrls() becomes a no-op. On staging/dev the secrets differ, so
// replacements are applied. Empty-string current values (missing secrets) are also excluded.
